/**
 * Rôles applicatifs (doc 01, § 2).
 *
 * Tous les utilisateurs sont internes à la SDG : il n'existe ni compte
 * d'agence ni compte client, donc aucun cloisonnement par périmètre.
 * L'habilitation se joue uniquement sur le rôle.
 */
export const ROLES = [
  'MIDDLE_BO',
  'GERANT',
  'RESP_GESTION',
  'CONFORMITE',
  'DIRECTION',
  'ADMIN',
] as const;

export type Role = (typeof ROLES)[number];

export const LIBELLE_ROLE: Record<Role, string> = {
  MIDDLE_BO: 'Middle / back-office',
  GERANT: 'Gérant',
  RESP_GESTION: 'Responsable de gestion',
  CONFORMITE: 'Conformité',
  DIRECTION: 'Direction',
  ADMIN: 'Administration',
};

/** Rôles habilités à valider une opération (deuxième paire d'yeux). */
export const ROLES_VALIDATEURS: readonly Role[] = ['RESP_GESTION'];

/**
 * Cumuls signalés à la conformité (doc 01, § 2). Non bloquants : ils
 * permettent à une même personne de saisir et de valider sur des maillons
 * différents de la même chaîne.
 */
export const CUMULS_SENSIBLES: readonly (readonly [Role, Role])[] = [
  ['GERANT', 'MIDDLE_BO'],
  ['RESP_GESTION', 'MIDDLE_BO'],
];

export function estRole(valeur: string): valeur is Role {
  return (ROLES as readonly string[]).includes(valeur);
}

export function cumulsSensiblesDe(roles: readonly Role[]): readonly (readonly [Role, Role])[] {
  return CUMULS_SENSIBLES.filter(([a, b]) => roles.includes(a) && roles.includes(b));
}
